import { NgModule } from '@angular/core';
import {
  LucideAngularModule,
  ArrowLeft,
  ArrowRight,
  ArrowLeftToLine,
  ArrowRightToLine,
  Box,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  ChevronLeft,
  Copy,
  Eye,
  Gauge,
  Scroll,
  Plug,
  Settings,
  BookOpen,
  Radar,
  Brain,
  Circle,
  Square,
  MessagesSquare,
  List,
  SquarePlay,
  User,
  AlertTriangle,
  NotepadText,
  X,
  Search,
  MessageSquare,
  EyeOff,
  Globe,
  File,
  TriangleAlert,
  KeyRound,
  ExternalLink,
  Users,
  GripVertical,
  UserPen,
  Trash2,
  Settings2,
  RotateCcw,
  Shield,
  ShieldAlert,
  ShieldBan,
  ShieldMinus,
  ShieldX,
  Unplug,
  Check,
  Lightbulb,
  Rocket,
  Download,
  Info,
  Zap,
  Plus,
  Sparkles,
  CheckCircle2,
  CircleCheck,
  CircleCheckBig,
  Loader,
  LoaderCircle,
  Lock,
  FileText,
  ShieldCheck,
  Scan,
  ScanLine,
  Ban,
  CircleDot,
  CircleX,
  Clock,
  ClockFading,
  CircleAlert,
  OctagonX,
  Minus,
  Maximize2,
  Minimize2,
} from 'lucide-angular';

@NgModule({
  imports: [
    LucideAngularModule.pick({
      ArrowLeft,
      ArrowRight,
      ArrowLeftToLine,
      ArrowRightToLine,
      Box,
      ChevronDown,
      ChevronUp,
      ChevronRight,
      ChevronLeft,
      Copy,
      Eye,
      Gauge,
      Scroll,
      Plug,
      Settings,
      BookOpen,
      Radar,
      Brain,
      Circle,
      Square,
      MessagesSquare,
      List,
      SquarePlay,
      User,
      AlertTriangle,
      NotepadText,
      X,
      Search,
      MessageSquare,
      EyeOff,
      Globe,
      File,
      TriangleAlert,
      KeyRound,
      ExternalLink,
      Users,
      GripVertical,
      UserPen,
      Trash2,
      Settings2,
      RotateCcw,
      Shield,
      ShieldAlert,
      ShieldBan,
      ShieldMinus,
      ShieldX,
      Unplug,
      Check,
      Lightbulb,
      Rocket,
      Download,
      Info,
      Zap,
      Plus,
      Sparkles,
      CheckCircle2,
      CircleCheck,
      CircleCheckBig,
      Loader,
      LoaderCircle,
      Lock,
      FileText,
      ShieldCheck,
      Scan,
      ScanLine,
      Ban,
      CircleDot,
      CircleX,
      Clock,
      ClockFading,
      CircleAlert,
      OctagonX,
      Minus,
      Maximize2,
      Minimize2,
    }),
  ],
  exports: [LucideAngularModule],
})
export class LucideIconsModule {}
